import { SuggestionTile } from "@mirage/mosaics/SuggestionTile/SuggestionTile";
import { memo } from "react";

interface PromotionSuggestionChipProps {
  text: string;
  isLoading?: boolean;
  onSubmit: () => void;
}

export const PromotionSuggestionChip = memo(
  ({ text, onSubmit, isLoading, ...args }: PromotionSuggestionChipProps) => {
    //TODO(DISCOVERY-7310) Add PAP logging

    return (
      <div data-testid="promotion-suggestion-chip">
        <SuggestionTile
          {...args}
          text={text}
          isLoading={isLoading}
          display="inline"
          size="medium"
          onClick={onSubmit}
        />
      </div>
    );
  },
);

PromotionSuggestionChip.displayName = "PromotionSuggestionChip";
